import { Link } from 'react-router-dom';
import { heroArticles } from '@/mocks/homeData';

export default function HeroSection() {
  const mainArticle = heroArticles[0];

  return (
    <section className="relative w-full min-h-[600px] flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20abstract%20artistic%20composition%20with%20deep%20crimson%20red%20and%20black%20ink%20wash%20textures%2C%20mysterious%20intense%20atmosphere%2C%20bold%20cinematic%20lighting%20with%20warm%20accent%20highlights%2C%20sophisticated%20editorial%20magazine%20style%20background%2C%20wide%20panoramic%20format%2C%20negative%20space%20for%20text%2C%20entertainment%20news%20portal%20aesthetic%2C%20high%20contrast%20moody%20artistic%20design%20with%20organic%20flowing%20patterns&width=1800&height=900&seq=home-hero-bg-01&orientation=landscape"
          alt="每日黑料头条背景"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-primary-500/90 text-background-50 px-4 py-1.5 rounded-full text-sm font-medium mb-6">
            <i className="ri-fire-line"></i>
            今日头条爆料
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
            {mainArticle.title}
          </h1>

          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            {mainArticle.summary}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="whitespace-nowrap px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors"
            >
              查看详情
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to={`/category/${mainArticle.categorySlug}`}
              className="whitespace-nowrap px-8 py-3 border border-white/40 text-white rounded-full font-medium text-sm hover:bg-white/10 transition-colors"
            >
              更多{mainArticle.category}
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
            {heroArticles.slice(1).map((article) => (
              <Link
                key={article.slug}
                to="/category/all"
                className="group bg-white/10 backdrop-blur-sm rounded-lg p-4 text-left hover:bg-white/20 transition-colors border border-white/10"
              >
                <span className="inline-block text-xs text-primary-300 bg-primary-500/20 px-2 py-0.5 rounded-full mb-2">
                  {article.category}
                </span>
                <h3 className="text-sm font-medium text-white group-hover:text-primary-300 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-white/50">
                  <span><i className="ri-eye-line mr-1"></i>{(article.views / 10000).toFixed(1)}万</span>
                  <span><i className="ri-message-2-line mr-1"></i>{article.comments}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}